import { gql } from '@apollo/client';
import { BIDS_FIELDS } from '../queries';

export const GET_BIDS = gql`
  query getBids(
    $wsId: String!
    $search: String
    $offset: Float!
    $amount: Float!
    $sortOnField: GetBidsSortInput
    $rejected: Boolean
    $stageIds: [String!]
  ) {
    getBids(
      input: {
        wsId: $wsId
        search: $search
        pagination: { amount: $amount, offset: $offset }
        rejected: $rejected
        sort: $sortOnField
        stageIds: $stageIds
      }
    ) {
      total
      bids {
        ...bidsFields
      }
    }
  }
  ${BIDS_FIELDS}
`;

export const GET_TOTAL_BIDS = gql`
  query getTotalBids(
    $wsId: String!
    $search: String
    $offset: Float!
    $amount: Float!
    $sortOnField: GetBidsSortInput
    $rejected: Boolean
    $stageIds: [String!]
  ) {
    getBids(
      input: {
        wsId: $wsId
        search: $search
        pagination: { amount: $amount, offset: $offset }
        rejected: $rejected
        sort: $sortOnField
        stageIds: $stageIds
      }
    ) {
      totalBids
    }
  }
`;

export const GET_BID = gql`
  query getBid($bidId: String!) {
    getBidV2(input: { bidId: $bidId }) {
      id
      workspace {
        id
      }
      status {
        id
      }
      itemId
      bidStageId
    }
  }
`;

export const CREATE_BIDS = gql`
  mutation createBids($workspaceId: String!, $itemType: BidItemType!, $items: [CreateBidItemInput!]!) {
    createBids(input: { workspaceId: $workspaceId, itemType: $itemType, items: $items }) {
      id
      itemId
      workspace {
        id
      }
      bidStageId
      status {
        id
      }
    }
  }
`;

export const UPDATE_BIDS_WS = gql`
  mutation updateBidsWorkspace($workspaceId: String!, $bidsIds: [String!]!) {
    updateBidsWorkspaceV2(input: { workspaceId: $workspaceId, bidsIds: $bidsIds }) {
      id
      itemId
      workspace {
        id
      }
      bidStageId
      status {
        id
      }
    }
  }
`;

export const UPDATE_BID_STATUS = gql`
  mutation updateBidStatus($bidId: String!, $statusId: String!) {
    updateBidStatusV2(input: { bidId: $bidId, statusId: $statusId }) {
      id
      itemId
      workspace {
        id
      }
      bidStageId
      status {
        id
      }
    }
  }
`;
